import { MovingPlatform } from "./MovingPlatform";

    export class MovingPlatformsManager  {

        public static s_currentMovingPlatformsManager: MovingPlatformsManager;

        private static REVERSE_TIME: number = 1150;

        private game: Phaser.Game;
        private platforms: MovingPlatform[];
        private refPlatform: MovingPlatform;
        private numPlatforms: number;
        private updateAllowed: boolean;

        constructor(game: Phaser.Game) {

            this.game = game;

            this.platforms = [];
            this.updateAllowed = true;

            MovingPlatformsManager.s_currentMovingPlatformsManager = this;
        }

        public addPlatform (platform: MovingPlatform): void {

            this.platforms.push( platform );
        }

        // por no cargar el bucle
        public init(): void {

            this.refPlatform = this.platforms[0];
            this.numPlatforms = this.platforms.length;
        }

        public update(): void {

            if (this.updateAllowed) {

                if (this.refPlatform.hasReachedLimit()) {

                    let i: number = this.numPlatforms;

                    while (i--) {

                        this.platforms[i].stop();
                    }

                    this.game.time.events.add(MovingPlatformsManager.REVERSE_TIME, this.reverseDirection, this);
                }
            }
        }

        public platformBurnt( platform: MovingPlatform): void {

            // sacarla del array
            let i = this.platforms.indexOf(platform);
            this.platforms.splice(i, 1);
            this.numPlatforms = this.platforms.length;

            if (this.platforms.length === 0) {
                this.updateAllowed = false;
                return;
            }

            // mirar si es la que marcaba el ritmo
            if (this.refPlatform === platform) {
                this.refPlatform = this.platforms[0];
            }
        }

        private reverseDirection(): void {

            let i = this.numPlatforms;

            while (i--) {

                this.platforms[i].reverse();
            }
        }
    }
